import AvatarSection from './AvatarSection.jsx';

export default AvatarSection;



// WEBPACK FOOTER //
// ./src/components/Header/Nav/AvatarSection/index.js